<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="46" height="42" viewBox="0 0 46 42">
        <g fill="none" fill-rule="evenodd">
            <g>
                <g>
                    <g>
                        <path fill="#2D3E4F" fill-rule="nonzero" d="M24.54 28.834l.542-16.226h-3.178l.541 16.226h2.096zm-1.047 6.659c1.014 0 1.86-.879 1.86-1.86 0-1.013-.846-1.858-1.86-1.858-1.014 0-1.86.845-1.86 1.859 0 .98.846 1.859 1.86 1.859z" transform="translate(-861 -362) translate(732 362) translate(129)"/>
                        <path stroke="#2D3E4F" stroke-width="2" d="M25.596 4.606l17.838 31.478c.817 1.442.31 3.273-1.131 4.09-.451.255-.96.39-1.48.39H5.149c-1.657 0-3-1.344-3-3 0-.519.135-1.029.39-1.48L20.376 4.606c.817-1.442 2.647-1.948 4.089-1.131.472.268.863.659 1.131 1.131z" transform="translate(-861 -362) translate(732 362) translate(129)"/>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'error-icon'
}
</script>
